import { render } from "./DemoMessagingView.vue?vue&type=template&id=6a39f274&scoped=true"
import script from "./DemoMessagingView.vue?vue&type=script&lang=js"
export * from "./DemoMessagingView.vue?vue&type=script&lang=js"

import "./DemoMessagingView.vue?vue&type=style&index=0&id=6a39f274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a39f274"]])

export default __exports__